import { render, staticRenderFns } from "./CustomerBasic.vue?vue&type=template&id=e26a1fba"
import script from "./CustomerBasic.vue?vue&type=script&lang=ts"
export * from "./CustomerBasic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports